/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import type { CaiAction } from "./choice-widget/action";

export interface ChoiceMessage {
	choices: CaiAction[];
	animate?: boolean;
	isMultiple?: boolean;
	selectedValues?: unknown[];
	resolve: (value: unknown) => void;
	reject?: (reason?: unknown) => void;
}

@Injectable({
	providedIn: "root",
})
export class ChoiceManagerService {
	public readonly showSubject: Subject<ChoiceMessage> =
		new Subject<ChoiceMessage>();

	public async show(
		choices: CaiAction[],
		options: {
			animate: boolean;
			isMultiple?: boolean;
			selectedValues?: unknown[];
		} = { animate: false, isMultiple: false, selectedValues: [] },
	): Promise<unknown> {
		return new Promise((resolve, reject) => {
			console.log("SHOW CHOICES", choices);
			this.showSubject.next({
				animate: options.animate,
				isMultiple: options.isMultiple,
				selectedValues: options.selectedValues,
				choices,
				resolve,
				reject,
			});
		});
	}
}
